(ns minorodata.tables-metadata.events
  (:require [re-frame.core :refer [reg-event-fx]]))

(reg-event-fx
 :tables-metadata.events/init
 (fn []
   {:dispatch-n [[:tables-metadata/add]
                 [:tables-metadata.api/search]]}))

